import { z } from 'zod';

export const findDemoSlotsSchema = z.object({
  date: z.date({ coerce: true }).optional(),
  limit: z.number({ coerce: true }).int().min(1).optional(),
});

export const findDemoSlotsResponse = z.object({
  data: z.object({
    startTime: z.date({ coerce: true }),
    endTime: z.date({ coerce: true }),
  }).array(),
});

export type FindDemoSlotsSchema = z.infer<typeof findDemoSlotsSchema>;

export type FindDemoSlotsResponse = z.infer<typeof findDemoSlotsResponse>;
